<template>
  <div v-if="!isUserAgreedToTerms" class="cookie-popup">
    <p>
      By using this website, you agree to the
      <router-link :to="{ name: 'Legal', hash: '#terms-and-conditions' }" target="_blank">
        Terms & Conditions
      </router-link>
      and
      <router-link :to="{ name: 'Legal', hash: '#privacy-policy' }" target="_blank">
        Privacy policy</router-link
      >.
    </p>
    <button aria-label="Agree to terms and close popup" class="small-button" @click="closePopup">
      Got it
    </button>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'

export default {
  name: 'AgreeToTermsPopup',
  data() {
    return {
      isUserAgreedToTerms: false,
    }
  },
  created() {
    this.isUserAgreedToTerms =
      Cookies.get('MzingoPartnersUserAgreedToTermsAndConditionsAndPrivacyPolicy') === 'true'
  },
  methods: {
    closePopup() {
      Cookies.set('MzingoPartnersUserAgreedToTermsAndConditionsAndPrivacyPolicy', 'true', {
        secure: true,
        expires: 365,
      })
      this.isUserAgreedToTerms = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins/buttons';

.cookie-popup {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  min-height: 80px;
  width: 100%;
  padding: 0 12px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  background-color: $accent-inverted;

  @media screen and (max-width: 440px) {
    flex-direction: column;

    p {
      margin-bottom: 0;
    }
  }

  a {
    color: $primary;
  }

  .small-button {
    min-width: 60px;
  }
}
</style>
